<template>
  <div class="character">
    <h2 class="character__title">
      {{model.title}} <span v-if="model.isRequired" class="color-red">*</span>
    </h2>
    <div class="character__wrap" :class="{'character__wrap--invalid': model.invalid}">
      <div v-show="model.invalid" class="character__popup">
        <p v-for="(error, i) in errors" :key="i">{{error}}</p>
      </div>
      <div @click="toggle" class="character__top">
        <div v-show="!opened" class="character__placeholder">
          1. Выбор характеристики позиции
        </div>
        <button
          class="btn-toggle character__toggle"
          :class="{'character__toggle--opened': opened}"
        >Toggle</button>
        <button
          v-tooltip="model.comment"
          @click.stop
          class="btn-toggle character__info"
          :disabled="!model.comment"
        >Tooltip</button>
      </div>
      <div v-show="opened" class="character__content">
        <div class="form-group">
          <label>
            Текстовое поле
          </label>
          <input v-model="value" @input="update" class="form-control">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'textField',
  props: ['model'],
  data() {
    return {
      value: undefined,
      opened: false,
      errors: [],
    };
  },
  mounted() {
    this.model.invalid = false;
    if (this.model.isRequired) {
      this.errors.push('Необходимо заполнить это поле');
    }
  },
  methods: {
    update() {
      this.value = this.value.replace(/ {1,}/g, ' ');
      this.value = this.value.replace('ё', 'е');
      this.value = this.value.replace(/[@#$^&*{}?`~_]+/g, '');

      const { title, isRequired } = this.model;
      const { value } = this;
      this.errors = [];
      if (isRequired && value === undefined) {
        this.errors.push('Необходимо заполнить это поле');
      }
      this.$emit('update', {
        title,
        value,
        model: this.model,
      });
    },
    toggle() {
      this.opened = !this.opened;
    },
  },
};
</script>
